import {
  setShouldDisplayAlternativeOffers,
  setSoldoutOfferById
} from 'modules/accommodation/slice'
import {getFilteredRoomsData} from 'modules/searchApi/selectors'
// eslint-disable-next-line no-restricted-imports
import {toggle} from 'opticks'

import {
  getOnAuthSuccessLandingUrl,
  removeOnAuthSuccessLandingUrl
} from '@vio/core/src/auth/business/persistData'
import {
  TRACKING_TIMEOUT_BEFORE_NAVIGATING_AWAY,
  userSuccessfullyAuthenticated,
  userSuccessfullyAuthenticatedWithEmail
} from '@vio/core/src/auth/modules/actions'
import {offerCheckApi} from '@vio/core/src/offer/services/offerCheckApi'
import {setIsPhoneVerified} from '@vio/shared/src/authentication/OneTimePassword/slice'

import {MiddlewareType} from '../middlewareList'

const accommodationMiddleware: MiddlewareType = store => next => action => {
  if (
    [
      userSuccessfullyAuthenticated.type,
      userSuccessfullyAuthenticatedWithEmail.type
    ].includes(action.type)
  ) {
    const successLandingUrl = getOnAuthSuccessLandingUrl()
    if (successLandingUrl) {
      setTimeout(() => {
        removeOnAuthSuccessLandingUrl()
        window.location.href = successLandingUrl
      }, TRACKING_TIMEOUT_BEFORE_NAVIGATING_AWAY)
      return
    }
  }
  if (offerCheckApi.endpoints.getOfferCheck.matchFulfilled(action)) {
    const {onSuccess} = action.meta.arg.originalArgs.options

    if (onSuccess) {
      onSuccess({httpRequestId: action.payload.httpRequestId})
    }
  }

  if (offerCheckApi.endpoints.getOfferCheck.matchRejected(action)) {
    const {dispatch, getState} = store
    const state = getState()
    const {rooms, splitBooking} = getFilteredRoomsData(state)
    const {offerId} = action.meta.arg.originalArgs.options
    dispatch(setSoldoutOfferById(offerId))

    const roomOfferIds = rooms.flatMap(room =>
      room.offers.map(offer => offer.id)
    )

    const soldOutOfferIds = {
      ...state.accommodation.soldoutOfferIds,
      [offerId]: true
    }

    const bundleId = splitBooking?.bundleId
    const allRoomOfferIds = [...roomOfferIds, ...(bundleId ? [bundleId] : [])]

    const isAllSoldOut =
      allRoomOfferIds.length > 0 &&
      allRoomOfferIds.every(id => soldOutOfferIds[id])

    if (
      toggle(
        '6124151-don_t_show_alternative_offers_on_offer-check_ap',
        true,
        isAllSoldOut
      )
    ) {
      dispatch(setShouldDisplayAlternativeOffers(true))
    }
  }

  if (setIsPhoneVerified.match(action)) {
    const state = store.getState()
    const redirectUrl = state.accommodation?.paymentSuccessRedirectUrl
    if (action.payload === true && redirectUrl) {
      setTimeout(() => {
        window.location.href = redirectUrl
      }, TRACKING_TIMEOUT_BEFORE_NAVIGATING_AWAY)
    }
  }
  return next(action)
}

export default accommodationMiddleware
